import {
  IonSkeletonText,
  IonHeader,
  IonToolbar,
  IonContent,
  IonItem,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import React from "react";

const Skeleton__MarketData: React.FC = () => {
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* 1. Top Segment Tabs Skeleton */}
      <IonSegment scrollable={true} style={{ height: "45px" }}>
        {[1, 2, 3].map((i) => (
          <IonSegmentButton key={i} disabled style={{ minWidth: "100px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "0 8px",
              }}
            >
              <IonSkeletonText
                animated
                style={{ width: "60px", height: "14px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "16px", height: "16px", borderRadius: "50%" }}
              />
            </div>
          </IonSegmentButton>
        ))}
      </IonSegment>

      {/* 2. Market Data Header Skeleton */}
      <IonItem
        lines="none"
        style={{
          "--min-height": "48px",
          "--background": "rgba(255,255,255,0.03)",
          marginTop: "2px",
        }}
      >
        <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
          <div style={{ flex: "2" }}>
            <IonSkeletonText
              animated
              style={{ width: "70%", height: "10px", marginBottom: "4px" }}
            />
            <IonSkeletonText
              animated
              style={{ width: "90%", height: "10px" }}
            />
          </div>
          <div style={{ flex: "1", textAlign: "center" }}>
            <IonSkeletonText
              animated
              style={{
                width: "40%",
                height: "10px",
                margin: "0 auto 4px auto",
              }}
            />
            <IonSkeletonText
              animated
              style={{ width: "40%", height: "10px", margin: "0 auto" }}
            />
          </div>
          <div style={{ flex: "1", textAlign: "right" }}>
            <IonSkeletonText
              animated
              style={{
                width: "40%",
                height: "10px",
                marginLeft: "auto",
                marginBottom: "4px",
              }}
            />
            <IonSkeletonText
              animated
              style={{ width: "40%", height: "10px", marginLeft: "auto" }}
            />
          </div>
        </div>
      </IonItem>

      {/* 3. Repeating List Items Skeleton */}
      <IonContent>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div
            key={i}
            style={{
              padding: "12px 16px",
              borderBottom: "1px solid rgba(255,255,255,0.05)",
              display: "flex",
              alignItems: "center",
              height: "75px",
            }}
          >
            {/* Left Column: Contract Details */}
            <div style={{ flex: "2" }}>
              <IonSkeletonText
                animated
                style={{ width: "80%", height: "18px", marginBottom: "8px" }}
              />
              <div style={{ display: "flex", gap: "10px" }}>
                <IonSkeletonText
                  animated
                  style={{ width: "30%", height: "12px" }}
                />
                <IonSkeletonText
                  animated
                  style={{ width: "20%", height: "12px" }}
                />
                <IonSkeletonText
                  animated
                  style={{ width: "25%", height: "12px" }}
                />
              </div>
            </div>

            {/* Middle Column: Bid Data */}
            <div
              style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IonSkeletonText
                animated
                style={{ width: "50%", height: "16px", marginBottom: "4px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "30%", height: "10px" }}
              />
            </div>

            {/* Right Column: Offer Data */}
            <div
              style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <IonSkeletonText
                animated
                style={{ width: "50%", height: "16px", marginBottom: "4px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "30%", height: "10px" }}
              />
            </div>
          </div>
        ))}
      </IonContent>
    </div>
  );
};

export default Skeleton__MarketData;
